import styled from "styled-components";
import { ListItemButton, ListItemText } from "@mui/material";

export const StyledListItemButton = styled(ListItemButton)`
    padding: 12px 20px;
    background-color: var(--color-white);
    border-radius: var(--radius-5);
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.15);

    svg {
        circle {
            fill: var(--color-tertiary);
        }

        path {
            fill: var(--color-tertiary-fg);
        }
    }
`;

export const StyledListItemText = styled(ListItemText)`
    span {
        color: var(--color-grey-800);
        font-weight: var(--weight-600);
    }
`;
